import Vue from 'vue'
import Router from 'vue-router'
import multiguard from 'vue-router-multiguard'

import { generalMiddleware, getDatetimeMiddleware, userActionMiddleware } from '@/router/middleware'

// Components
import NotFound from '@/components/Layouts/Main/NotFound'

// Pages
import About from '@/components/Layouts/Pages/About'
import Privacy from '@/components/Layouts/Pages/Privacy'
import TOS from '@/components/Layouts/Pages/TOS'
import Contact from '@/components/Layouts/Pages/Contact'

// User Routes
import Login from '@/components/User/Login.vue'
import Signup from '@/components/User/Signup.vue'
import Forgot from '@/components/User/Forgot.vue'
import Reset from '@/components/User/Reset.vue'

// Program
import Home from '@/components/Layouts/Program/Home'
import Dashboard from '@/components/Layouts/Program/Dashboard.vue'

// Use router
Vue.use(Router)

// Non route component registering
Vue.component('navbar', require('@/components/Partials/Main/Navbar.vue').default)
Vue.component('footer-main', require('@/components/Partials/Main/FooterMain.vue').default)
Vue.component('back-to-top', require('@/components/Partials/Components/BackToTop.vue').default)
Vue.component('general-header', require('@/components/Partials/Components/GeneralHeader.vue').default)

// Program Non route components
Vue.component('category-label', require('@/components/Partials/Program/CategoryLabel.vue').default)
Vue.component('product', require('@/components/Partials/Program/Product.vue').default)
Vue.component('product-info-modal', require('@/components/Partials/Modals/ProductInfoModal.vue').default)
Vue.component('product-reviews-modal', require('@/components/Partials/Modals/ProductReviewsModal.vue').default)

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '*',
            name: 'notFound',
            component: NotFound,
            meta: {
                title: 'Not Found',
                partialType: 'meta'
            },
            beforeEnter: multiguard([generalMiddleware])
        },
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                title: 'Home | Browse and Search the Best Selling Producs on Amazon | Best Meta',
                partialType: 'full'
            },
            beforeEnter: multiguard([generalMiddleware, getDatetimeMiddleware, userActionMiddleware])
        },
        {
            path: '/about',
            name: 'about',
            component: About,
            meta: {
                title: 'About | Best Meta',
                partialType: 'full'
            },
            beforeEnter: multiguard([generalMiddleware, getDatetimeMiddleware, userActionMiddleware])
        },
        {
            path: '/privacy',
            name: 'privacy',
            component: Privacy,
            meta: {
                title: 'Privacy | Best Meta',
                partialType: 'full'
            },
            beforeEnter: multiguard([generalMiddleware, getDatetimeMiddleware, userActionMiddleware])
        },
        {
            path: '/tos',
            name: 'tos',
            component: TOS,
            meta: {
                title: 'TOS | Best Meta',
                partialType: 'full'
            },
            beforeEnter: multiguard([generalMiddleware, getDatetimeMiddleware, userActionMiddleware])
        },
        {
            path: '/contact',
            name: 'contact',
            component: Contact,
            meta: {
                title: 'Contact | Best Meta',
                partialType: 'full'
            },
            beforeEnter: multiguard([generalMiddleware, getDatetimeMiddleware, userActionMiddleware])
        },

        // User
        {
            path: '/user/login',
            component: Login,
            name: 'login',
            meta: {
                title: 'Login',
                partialType: 'full'
            },
            beforeEnter: multiguard([generalMiddleware, getDatetimeMiddleware, userActionMiddleware])
        },
        {
            path: '/user/signup',
            component: Signup,
            name: 'signup',
            meta: {
                title: 'Signup',
                partialType: 'full'
            },
            beforeEnter: multiguard([generalMiddleware, getDatetimeMiddleware, userActionMiddleware])
        },
        {
            path: '/user/forgot',
            component: Forgot,
            name: 'forgot',
            meta: {
                title: 'Forgot',
                partialType: 'full'
            },
            beforeEnter: multiguard([generalMiddleware, getDatetimeMiddleware, userActionMiddleware])
        },
        {
            path: '/user/reset',
            component: Reset,
            name: 'reset',
            meta: {
                title: 'Reset',
                partialType: 'full'
            },
            beforeEnter: multiguard([generalMiddleware, getDatetimeMiddleware, userActionMiddleware])
        },

        // Program
        {
            path: '/dashboard',
            component: Dashboard,
            name: 'dashboard',
            meta: {
                title: 'Dashboard',
                partialType: 'account',
                requiresAuth: true
            },
            beforeEnter: multiguard([generalMiddleware, getDatetimeMiddleware, userActionMiddleware])
        },
    ],
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else if (to.hash) {
            return {
                selector: to.hash
            }
        }  else {
            return { x: 0, y: 0 }
        }
    }
})

router.afterEach((to, from) => {
    // End our vue-progressbar
    router.app.$Progress.finish()
})

export default router
